import React, { useEffect } from 'react';
import { AuthContextType, Props } from './types';
import useMediaQuery from 'core/hooks/useMediaQuery';
import { MobileComponent } from 'features/Authentication/components/MobileComponent';

// Main Context
export const AuthContext = React.createContext<AuthContextType>(
  {} as AuthContextType,
);

const AuthContextProvider: React.FC<Props> = ({ value, children }) => {
  const isLandingPage = window.location.pathname === "/";
  const isDesktop = useMediaQuery('(min-width: 800px)');

  return (isDesktop || isLandingPage) ? <AuthContext.Provider value={value}>{children}</AuthContext.Provider> : <MobileComponent
    username={"asdasd"}
    setUsername={() => { }}
    password={""}
    setPassword={() => { }}
    handleLogin={() => { }}
  />;
};

export default AuthContextProvider;

export const useAuth = () => {
  const ctx = React.useContext(AuthContext);
  return ctx.authData;
};

export const useSetAuth = () => {
  const ctx = React.useContext(AuthContext);
  return ctx.setCurrentRole;
};

export const useSetAcademicYear = () => {
  const ctx = React.useContext(AuthContext);
  return ctx.setAcademicYear;
};

export const useSetBranchID = () => {
  const ctx = React.useContext(AuthContext);
  return ctx.setBranchID;
};
